import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  formSignIn: FormGroup;
  errorNotification = false;
  messageNotification = '';
  checkUsername = false;
  checkEmail = false;
  checkPassword = false;
  messageCheckUsername = '';
  messageCheckEmail = '';
  messageCheckPassword = '';

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private httpService: HttpService,
    private translate: TranslateService,
    private form_build: FormBuilder,
    private router: Router
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.translate.use(sessionStorage.getItem('language'));
      if (sessionStorage.getItem('user-info')) {
        this.router.navigateByUrl('/admin');
      }
    }
    this.formSignIn = this.form_build.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  onLogin(): void {
    // const compareUsername = /^[a-zA-Z'\s]{5,50}$/;
    const compareEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const comparePassword = /^[\w-!@#$%^&*' ']{5,20}$/;
    /*if (compareUsername.test(String(this.formSignIn.controls.username.value).toLowerCase()) === false) {
      this.checkUsername = true;
      this.messageCheckUsername = 'Please enter a valid username.';
    } else {
      this.checkUsername = false;
    }*/
    if (compareEmail.test(String(this.formSignIn.controls.username.value).toLowerCase()) === false) {
      this.checkUsername = true;
      this.messageCheckUsername = 'Please enter a valid email.';
    } else {
      this.checkUsername = false;
    }
    if (comparePassword.test(String(this.formSignIn.controls.password.value).toLowerCase()) === false) {
      this.checkPassword = true;
      this.messageCheckPassword = 'Please enter a valid password.';
    } else {
      this.checkPassword = false;
    }
    if (!this.checkUsername && !this.checkPassword) {
      this.httpService.loginUser(this.formSignIn.value)
        .subscribe((data) => {
          if (data.err_code === 0) {
            sessionStorage.setItem('user-info', JSON.stringify(data.data));
            this.router.navigateByUrl('/admin');
          } else {
            this.messageNotification = data.err_msg;
            this.errorNotification = true;
            const that = this;
            setTimeout(function () {
              that.errorNotification = false;
            }, 3000);
          }
        });
    }
  }

}
